module.exports = __webpack_public_path__ + "static/media/newsukireland.257d6073.png";